/**
 * The optional free-text box. Its label comes from config when config supplies
 * one; the fallback is interface chrome, not item content.
 */
export function FreeText({ format, answer, onChange, disabled, name }) {
  const label = format.free_text_label || 'Anything you want to add (optional)'
  const max = typeof format.free_text_max === 'number' ? format.free_text_max : 500

  return (
    <div className="mt-3">
      <label htmlFor={`${name}-text`} className="mb-1 block text-sm text-[var(--ink-700)]">
        {label}
      </label>
      <textarea
        id={`${name}-text`}
        name={`${name}-text`}
        rows={3}
        maxLength={max}
        value={answer?.text ?? ''}
        disabled={disabled}
        onChange={(e) => onChange({ ...answer, text: e.target.value })}
        className="w-full rounded-[var(--r-surface)] border border-[var(--control-border)] bg-[var(--surface-raised)] px-3 py-2 text-base"
      />
    </div>
  )
}
